<template>
  <div style="text-align: left">
    <el-form ref="form" :model="couponForm" label-width="80px" v-if="user !== 'reader'">
      <el-form-item>
        <el-row>
          <el-col :offset="22" :span="2">
            <el-button type="primary" @click="onCreateClick()"><i class="el-icon-plus"></i> 创建</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-table
      :data="couponBatchList"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="编号">
      </el-table-column>
      <el-table-column
        prop="quantity"
        label="数量">
      </el-table-column>
      <el-table-column
        prop="expireAt"
        label="有效期至">
      </el-table-column>
      <el-table-column
        label="#">
        <template slot-scope="scope">
          <el-button @click="onModifyClick(scope.row)" type="primary" v-if="user !== 'reader'"><i class="el-icon-edit"></i> 编辑</el-button>


          <el-button @click="onDownload(scope.row.id)" type="success" v-if="user !== 'reader' && scope.row.status == '1'">
            <i class="el-icon-download"></i> 下载</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="优惠券创建" :visible.sync="showModal">
      <el-form :model="couponForm" :rules="rules" ref="couponForm" label-width="100px" class="coupon-form">
        <el-form-item label="数量" prop="title">
          <el-input :disabled="couponForm.id > 0" v-model="couponForm.quantity"></el-input>
        </el-form-item>

        <el-form-item label="优惠券描述" prop="content">
          <el-input type="textarea" :rows="4" v-model="couponForm.comment"></el-input>
        </el-form-item>

        <el-form-item label="有效期至" required>
          <el-col :span="12">
            <el-form-item prop="date">
              <el-date-picker type="date"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              placeholder="选择日期"
                              v-model="couponForm.expireAt"
                              style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button v-if="couponForm.id == '0'" type="primary" @click="doCreateOrUpdate()">立即创建</el-button>
          <el-button v-else type="primary" @click="doCreateOrUpdate()">立即更新</el-button>

        </el-form-item>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>
import * as api from "@/js/api.js"

export default {
  name: "CouponManagement",
  data() {
    return {
      showModal: false,
      shareDetails: [],
      couponBatchList: [
      ],
      dateRange: [],
      couponForm: {
        id: '0',
        type: '0',
        quantity: '',
        comment: '',
        expireAt: '',
      },
      rules: {
        quantity: [
          { required: true, message: '数量不能为空', trigger: 'change' },
          { type: 'number', min: 1, max: 1000, message: '一次最多只能生成1000个', trigger: 'change' }
        ],
        comment: [
          { required: true, message: '请输入优惠券相关描述', trigger: 'change' },
          { min: 5, max: 1000, message: '长度不小于5个字符，不超过1000个字符', trigger: 'change' }
        ],
        expireAt: [
          { type: 'date', required: true, message: '请选择过期时间', trigger: 'change' }
        ]
      },
      user: this.$store.state.CurrentUser,
    }
  },

  methods: {
    onModifyClick(row) {
      this.couponForm.id = row.id
      this.couponForm.type = row.type
      this.couponForm.quantity = row.quantity
      this.couponForm.comment = row.comment
      this.couponForm.expireAt = row.expireAt

      this.showModal = true
    },

    onDownload(id) {
      let params = {
        batchId: id
      }
      api.downloadCoupons(params).then(res => {
        const blob = res.data
        const a = document.createElement("a")
        a.href = URL.createObjectURL(blob)
        a.download = id + '.csv'
        a.click()
        URL.revokeObjectURL(a.href)
        a.remove();
      })
    },

    onCreateClick() {
      this.couponForm.id = '0'
      this.couponForm.type = '0'
      this.couponForm.quantity = '0'
      this.couponForm.comment = ''
      this.couponForm.expireAt = ''
      this.showModal = !this.showModal
    },

    doCreateOrUpdate() {
      api.createCouponBatch(this.couponForm).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('操作失败')
        } else {
          this.$message.success('操作成功')
          this.showModal = false
          this.getCouponBatchList()
        }
      })
    },

    getCouponBatchList() {
      api.getAllCouponBatch({}).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('数据获取出错')
        } else {
          this.couponBatchList = result.data
        }
      })
    }
  },

  mounted() {
    this.getCouponBatchList()
  },
}
</script>

<style scoped>

.pagination {
  margin-top: 15px;
}

</style>



// WEBPACK FOOTER //
// src/pages/tools/coupon/CouponManagement.vue